const PALETTE = ['#FFF1A7', '#ECE2FF', '#FED7D4', '#D4F0FE', '#D4FEDA'] as const;

export function randomTagColor(): string {
  return PALETTE[Math.floor(Math.random() * PALETTE.length)];
}
